import { render, staticRenderFns } from "./Game1-9.vue?vue&type=template&id=faa6717a&scoped=true&"
import script from "./Game1-9.vue?vue&type=script&lang=js&"
export * from "./Game1-9.vue?vue&type=script&lang=js&"
import style0 from "./Game1-9.vue?vue&type=style&index=0&id=faa6717a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa6717a",
  null
  
)

export default component.exports